const DAY = 86_400_000;

/**
 * Submissions created per day over the last `days`, plus the count for the
 * window before it, for a MetricPanel cell with a chart and a change line.
 */
export function submissionActivity(rows: { createdAt: string }[], days: number) {
  const now = Date.now();
  const since = now - days * DAY;
  const prevSince = since - days * DAY;
  const series: Record<string, number> = {};
  let current = 0;
  let previous = 0;
  for (let i = days - 1; i >= 0; i -= 1) {
    series[new Date(now - i * DAY).toISOString().slice(0, 10)] = 0;
  }
  for (const row of rows) {
    const t = new Date(row.createdAt).getTime();
    if (t >= since) {
      current += 1;
      const key = new Date(t).toISOString().slice(0, 10);
      series[key] = (series[key] ?? 0) + 1;
    } else if (t >= prevSince) {
      previous += 1;
    }
  }
  return { series, current, previous };
}

export function daysSince(iso: string) {
  return Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / DAY));
}

/** "Oldest waiting 3 days", or what to say when nothing waits. */
export function describeWaiting(oldestIso: string | null, nothing = "Nothing waiting") {
  if (oldestIso === null) return nothing;
  const d = daysSince(oldestIso);
  return d === 0 ? "Oldest arrived today" : `Oldest waiting ${d} ${d === 1 ? "day" : "days"}`;
}
